/**
 * UserDashboardContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import UserDashboardPresenter from './UserDashboardPresenter';
import MessageAlert from 'utils';
import { CartApi, StatisticsApi } from 'api';
import dayjs from 'dayjs';
// import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const UserDashboardContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [statisticsType, setStatisticsType] = useState('month');
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState({
    product: null,
    category: null,
    shop: null,
    rawData: null,
  });
  const [userStatics, setUserStatics] = useState(null);
  const [gradeStatics, setGradeStatics] = useState(null);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 카트목록 조회
   * --
   */
  const handleGetCartList = async (type) => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        `${type}-dashboard`
      );
      if (status !== 200) throw { message };

      setTimeout(() => {
        if (type === 'user') setUserStatics(data[0]);
        else if (type === 'grade') setGradeStatics(data);
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[UserDashboardContainer][handleGetCartList] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    handleGetCartList('user');
    handleGetCartList('grade');
  }, []);

  /* ===== RENDER ===== */
  const props = {
    loading,
    chartData,
    permission,
    statisticsType,
    setStatisticsType,
    handleGetCartList,

    //
    userStatics,
    gradeStatics,
  };
  // JSX: start
  return (
    <>
      <UserDashboardPresenter {...props} />
    </>
  ); // JSX: end
};

UserDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default UserDashboardContainer;
